// donorQueries.js
import { gql } from "@apollo/client";

export const GET_ELIGIBLE_DONORS = gql`
    mutation GetEligibleDonors($data: paginationInput!, $filter: StatisticsFilterInput) {
        getEligibleDonors(data: $data, filter: $filter) {
            total
            donors {
                _id
                profileImage
                status
                donorToken
                smsRecallType
                mobileRecallType
                emailRecallType
                workRecallType
                firstName
                secondName
                gender
                dateOfBirth
                locationOfBirth
                civilId
                mobilePhone
                email
                passport
                address
                city
                bloodType
                nationality
                reasonOfDonation
                socialStatus
                visits {
                    _id
                }
            }
        }
    }
`;

export const GET_NON_ELIGIBLE_DONORS = gql`
mutation GetNonEligibleDonors($data: paginationInput!, $filter: StatisticsFilterInput) {
    getNonEligibleDonors(data: $data, filter: $filter) {
total
donors {
    _id
    profileImage
    status
    donorToken
    smsRecallType
    mobileRecallType
    emailRecallType
    workRecallType
    firstName
    secondName
    gender
    dateOfBirth
    locationOfBirth
    civilId
    mobilePhone
    email
    passport
    address
    city
    bloodType
    nationality
    reasonOfDonation
    socialStatus
    visits{
      _id
    }
    
}
    }
}
`;

export const GET_DONORS_THAT_VISTED_MORE_THAN_THREE_TIMES = gql`
mutation GetDonorsWithMoreThanOrEq3Donations($data: paginationInput!, $filter: StatisticsFilterInput) {
    getDonorsWithMoreThanOrEq3Donations(data: $data, filter: $filter) {
        total
        donors {
            _id
            profileImage
            status
            donorToken
            smsRecallType
            mobileRecallType
            emailRecallType
            workRecallType
            firstName
            secondName
            gender
            dateOfBirth
            locationOfBirth
            civilId
            mobilePhone
            email
            passport
            address
            city
            bloodType
            nationality
            reasonOfDonation
            socialStatus
            visits {
                _id
            }
        }
    }
}


`;

export const GET_DONORS_WTIH_SPECIFIC_ABO_TYPE = gql`
mutation getDonorsWithSpecificABOType($data: paginationInput!, $type: String!) {
    getDonorsWithSpecificABOType(data: $data, type: $type) {
        total
        donors {
            _id
            profileImage
            status
            donorToken
            smsRecallType
            mobileRecallType
            emailRecallType
            workRecallType
            firstName
            secondName
            gender
            dateOfBirth
            locationOfBirth
            civilId
            mobilePhone
            email
            passport
            address
            city
            bloodType
            nationality
            reasonOfDonation
            socialStatus
            visits {
                _id
            }
        }
    }
}

`;

export const GET_DONOR_WTIH_SPECIFIC_GENDER = gql`
mutation getDonorsWithSpecificGender($gender: String!) {
    getDonorsWithSpecificGender(gender: $gender) {
        _id
        profileImage
        status
        donorToken
        smsRecallType
        mobileRecallType
        emailRecallType
        workRecallType
        firstName
        secondName
        gender
        dateOfBirth
        locationOfBirth
        civilId
        mobilePhone
        email
        passport
        address
        city
        bloodType
        nationality
        reasonOfDonation
        socialStatus
        visits {
            _id
        }
    }
}
`;

export const FILTER_DONORS_BY_DATE = gql`
mutation filterDonors($data: filterDonorsInput!) {
    filterDonors(data: $data) {
        _id
        profileImage
        status
        donorToken
        smsRecallType
        mobileRecallType
        emailRecallType
        workRecallType
        firstName
        secondName
        gender
        dateOfBirth
        locationOfBirth
        civilId
        mobilePhone
        email
        passport
        address
        city
        bloodType
        nationality
        reasonOfDonation
        socialStatus
        visits {
            _id
        }
    }
}
`;

export const GET_DONORS_GENDER_STATISTICS = gql`
  mutation GetDonorGenderStatistics($filter: StatisticsFilterInput) {
    getDonorGenderStatistics(filter: $filter) {
      total
      maleCount
      femaleCount
      malePercentage
      femalePercentage
      chartData {
        gender
        count
        percentage
      }
      summary {
        labels
        data
        percentages
      }
    }
  }
`;

export const GET_DONORS_AGE_STATISTICS = gql`
  mutation GetDonorAgeStatistics($filter: StatisticsFilterInput) {
    getDonorAgeStatistics(filter: $filter) {
      total
      age18to25
      age25to35
      age35to45
      age45plus
      chartData {
        category
        count
        percentage
      }
      summary {
        labels
        data
        percentages
      }
    }
  }
`;


export const GET_DONORS_GENDER_AGE_STATISTICS = gql`
  mutation GetDonorGenderAgeStatistics($filter: StatisticsFilterInput) {
    getDonorGenderAgeStatistics(filter: $filter) {
      total
      totalMale
      totalFemale
      ageRanges
      maleData
      femaleData
      chartData {
        labels
        datasets {
          label
          data
          backgroundColor
          borderColor
          borderWidth
        }
      }
    }
  }
`;


export const GET_BLOOD_GROUP_STATISTICS = gql`
  mutation GetBloodGroupStatistics($filter: StatisticsFilterInput) {
    getBloodGroupStatistics(filter: $filter) {
      total
      aPlus
      aMinus
      bPlus
      bMinus
      abPlus
      abMinus
      oPlus
      oMinus
      chartData {
        bloodGroup
        count
        percentage
      }
      summary {
        labels
        data
        percentages
      }
    }
  }
`;

export const GET_DONOR_BLOOD_GROUP_STATISTICS = gql`
  mutation GetDonorGenderBloodGroupStatistics($filter: StatisticsFilterInput) {
    getDonorGenderBloodGroupStatistics(filter: $filter) {
      totalDonors
      details {
        gender
        bloodGroups {
          bloodType
          count
          percentage
        }
      }
      summary {
        gender
        count
        percentage
      }
    }
  }
`;

export const GET_DONOR_COUNT_PER_CAMPAIGN = gql`
  query getDonorCountPerCampaign($filter: FilterVisitInput) {
    getDonorCountPerCampaign(filter: $filter) {
      campaignId
      campaignName
      donorCount
      startDate
      endDate
    }
  }
`;

export const GET_DONOR_COUNT_PER_COLLECTION_SITE = gql`
  query GetDonorCountPerCollectionSite($filter: FilterVisitInput) {
    getDonorCountPerCollectionSite(filter: $filter) {
      collectionSiteId
      collectionSiteName
      donorCount
    }
  }
`;

export const GET_ALL_CAMPAIGNS = gql`
  query GetAllCampaigns($locale: String!) {
    getAllCampaigns(locale: $locale) {
      id
      is_active
      start_date
      end_date
      campaign_data {
        campaignCode
        collection_site {
          id
          title
        }
      }
    }
  }
`;

export const GET_ALL_COLLECTION_SITES = gql`
  query GetAllCollectionSites {
    getCollectionSites {
      id
      title_en
      title_ar
    }
  }
`;